import { IRestResponse } from "@/loader";

export interface IDeleteRestResponse<I> extends IRestResponse {
	deleted: boolean;
	previous: I;
}

export function isDeleteRestResponse<I>(object: any): object is IDeleteRestResponse<I> {
	return "deleted" in object && "previous" in object;
}
